module.exports = __webpack_public_path__ + "img/jujiayanglao_image_ylms.d8d014af.png";